module.exports = __webpack_public_path__ + "static/media/mini_logo.0d467157.png";